<template>
  <div>
    <Modal class="my-modal" v-model="visible" :title="title" :mask-closable="false" :footer-hide="true">
      <Form ref="form" :model="formData" :label-width="90" class="formGauge">
        <FormItem label="图片" prop="url" :rules="$units.formRule.required('请选择图片')">
          <upLoadNew v-model="formData.imgArr" @change="imgUpload" @remove="$set(formData, 'url', '')">
          </upLoadNew>
        </FormItem>
        <FormItem label="海报名称" prop="title" :rules="$units.formRule.required('请输入海报名称')">
          <Input v-model="formData.title" clearable></Input>
        </FormItem>
        <FormItem label="所属分类" prop="columnIds" :rules="$units.formRule.arrRequired('请选择所属分类', 'change')">
          <Select v-model="formData.columnIds" :transfer="true" clearable multiple>
            <Option :value="items.id || ''" :key="items.id" v-for="items in polist">{{ items.name }}</Option>
          </Select>
        </FormItem>
        <FormItem label="展示机构" prop="orgIdList" key="orgIdList" :rules="$units.formRule.arrRequired('请选择展示机构', 'change')">
          <selectTree v-model="formData.orgIdList" :multiple="true" :maxTagCount="5" type="4" ref="selectTreeRef"
            :orgId="formData.buzOrganId" :showCloseIcon="false"></selectTree>
        </FormItem>
        <FormItem label="关联产品" prop="productCode">
          <Select :label-in-value="true" v-model="formData.productCode" placeholder="请选择" transfer filterable clearable
            multiple>
            <Option :value="product.productCode" v-for="product in productListArr" :key="product.id">{{
              product.productName }}</Option>
          </Select>
        </FormItem>
        <FormItem label="海报文案" prop="copywriting">
          <Input v-model="formData.copywriting" type="textarea"></Input>
        </FormItem>
        <FormItem label="创建人" v-if="formData.id" key="createName">
          <span style="line-height: 34px;">{{ formData.createName }}</span>
        </FormItem>
        <FormItem label="创建时间" v-if="formData.id" key="createTime">
          <span style="line-height: 34px;">{{ formData.createTime }}</span>
        </FormItem>
        <FormItem label="最后更新人" v-if="formData.id" key="updateName">
          <span style="line-height: 34px;">{{ formData.updateName }}</span>
        </FormItem>
        <FormItem label="更新时间" v-if="formData.id" key="updateTime">
          <span style="line-height: 34px;">{{ formData.updateTime }}</span>
        </FormItem>
      </Form>
      <div class="ivu-modal-footer">
        <Button type="primary" @click="visible = false" ghost>取消</Button>
        <Button type="primary" @click="submit">确定</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import upLoadNew from "@/components/commons/uploadNew";
import selectTree from '@/components/system/selectTree3';
export default {
  components: {
    upLoadNew,
    selectTree
  },
  data() {
    return {
      visible: false,
      title: '新增',
      formData: {},
      polist: [],
      productListArr: [],
    }
  },
  methods: {
    open(val) {
      this.visible = true
      this.$refs.form && this.$refs.form.resetFields();
      this.formData = {
        url: '',
        title: '',
        columnIds: [],
        copywriting: ''
      }
      this.getType()
      this.getProductList()
      this.$nextTick(() => {
        this.$refs.selectTreeRef && this.$refs.selectTreeRef.openChange(true);
      });
      if (val) {
        this.title = '编辑'
        this.formData = val
        this.$http({
          url: '/buz/cmsPoster/read/detail',
          type: "GET",
          data: {
            id: val.id
          }
        }).then(res => {
          this.formData = res.data
          if (this.formData.url) {
            this.formData.imgArr = [{ path: this.formData.url }]
          }

        })
      } else {
        this.title = '新增'
      }
    },
    getType() {
      this.$http({
        url: '/buz/cmsPoster/column/list',
        type: "POST",
        data: {}
      }).then(res => {
        this.polist = res.data
      })
    },
    // 产品
    getProductList() {
      this.$http({
        url: "/buz/productBase/read/short/list",
        type: "post",
        data: {
          pageNo: 1,
          pageSize: 9999,
        },
      }).then((res) => {
        this.productListArr = res.data;
      }).catch((err) => {
        console.log(err)
      });
    },
    imgUpload() {
      if (this.formData.imgArr && this.formData.imgArr[0]) {
        this.$set(this.formData, "url", this.formData.imgArr[0].path)
      }
      this.$refs.form.validateField('url');
    },
    submit() {
      let url
      if (this.formData.id) {
        url = '/buz/cmsPoster/edit'
      } else {
        url = '/buz/cmsPoster/add'
      }
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$http({
            url: url,
            type: "POST",
            data: this.formData
          }).then(res => {
            this.visible = false
            this.$emit('getPoster')
          })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.my-modal{
  /deep/ .wrapper .demo-upload-list img{
    object-fit: cover;
    object-position: top;
  }
}

</style>